/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReleaseRequest
 */
export interface ReleaseRequest {
    /**
     * Existing release id (from the lookup) to link; omit to create the release first
     * @type {string}
     * @memberof ReleaseRequest
     */
    releaseId?: string | null;
    /**
     * Required when creating; optional when linking
     * @type {string}
     * @memberof ReleaseRequest
     */
    source?: ReleaseRequestSourceEnum;
    /**
     * Release id at `source`, when creating
     * @type {string}
     * @memberof ReleaseRequest
     */
    sourceId?: string | null;
    /**
     * When creating with source `other`, may stand in for `source_id`
     * @type {string}
     * @memberof ReleaseRequest
     */
    sourceUrl?: string;
    /**
     * If already linked, from lookup response
     * @type {string}
     * @memberof ReleaseRequest
     */
    edgeId?: string | null;
    /**
     * When linking: the release's id(s) at its source, e.g. the Discogs release id the lookup was made with. `release_id` is the WMC ParentRelease id, so without this the source's own id never reaches `sourceReleaseId`. When creating it is `[source_id]`.
     * @type {Array<string>}
     * @memberof ReleaseRequest
     */
    sourceReleaseIds?: Array<string>;
    /**
     * Required when linking
     * @type {string}
     * @memberof ReleaseRequest
     */
    releaseTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseRequest
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseRequest
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseRequest
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReleaseRequest
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseRequest
     */
    format?: string;
    /**
     * Release barcode: 12-digit UPC or 13-digit EAN. Spaces and hyphens are ignored.
     * @type {string}
     * @memberof ReleaseRequest
     */
    barcode?: string;
    /**
     * OpenSearch document _id for the recording being edited
     * @type {string}
     * @memberof ReleaseRequest
     */
    documentId?: string | null;
}


/**
 * @export
 */
export const ReleaseRequestSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type ReleaseRequestSourceEnum = typeof ReleaseRequestSourceEnum[keyof typeof ReleaseRequestSourceEnum];



/**
 * Check if a given object implements the ReleaseRequest interface.
 */
export function instanceOfReleaseRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReleaseRequestFromJSON(json: any): ReleaseRequest {
    return ReleaseRequestFromJSONTyped(json, false);
}

export function ReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': !exists(json, 'release_id') ? undefined : json['release_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'edgeId': !exists(json, 'edge_id') ? undefined : json['edge_id'],
        'sourceReleaseIds': !exists(json, 'source_release_ids') ? undefined : json['source_release_ids'],
        'releaseTitle': !exists(json, 'releaseTitle') ? undefined : json['releaseTitle'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
    };
}

export function ReleaseRequestToJSON(value?: ReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'source': value.source,
        'source_id': value.sourceId,
        'source_url': value.sourceUrl,
        'edge_id': value.edgeId,
        'source_release_ids': value.sourceReleaseIds,
        'releaseTitle': value.releaseTitle,
        'dateReleased': value.dateReleased,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
        'barcode': value.barcode,
        'document_id': value.documentId,
    };
}

